var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCamera64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2252_9202)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.576 9.26367H36.4232C38.2234 9.26367 39.8204 10.419 40.3837 12.1289L41.7292 16.2134H22.27L23.6155 12.1289C24.1788 10.419 25.7757 9.26367 27.576 9.26367Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8455 12.0436H14.6254C15.393 12.0436 16.0153 12.6659 16.0153 13.4335V16.2134H10.4556V13.4335C10.4556 12.6659 11.0779 12.0436 11.8455 12.0436Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9338 16.2134H9.06581C6.76289 16.2134 4.896 18.0803 4.896 20.3832V49.5719C4.896 51.8748 6.76289 53.7417 9.06581 53.7417H54.9338C57.2367 53.7417 59.1036 51.8748 59.1036 49.5719V20.3832C59.1036 18.0803 57.2367 16.2134 54.9338 16.2134Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 48.8769C39.6764 48.8769 45.8993 42.6539 45.8993 34.9775C45.8993 27.3011 39.6764 21.0781 32 21.0781C24.3236 21.0781 18.1006 27.3011 18.1006 34.9775C18.1006 42.6539 24.3236 48.8769 32 48.8769Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1538 25.9429C53.3052 25.9429 54.2387 25.0095 54.2387 23.858C54.2387 22.7066 53.3052 21.7731 52.1538 21.7731C51.0023 21.7731 50.0688 22.7066 50.0688 23.858C50.0688 25.0095 51.0023 25.9429 52.1538 25.9429Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2252_9202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.00268555)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCamera64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCamera64.6e105782100aec6cf74fdc94dfc8965a.svg";
export { ForwardRef as ReactComponent };